import { AUTH_BASE_URL } from '../utils/ApiUrls';

class UserService {

  // Create organization method
  async createOrganization(organizationData) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/organizations/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(organizationData),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Organization creation failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }



  // Create user method
  async createUser(userData, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`, // Use admin's token
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      // if (!response.ok) {
      //   return {
      //     success: false,
      //     status: response.status,
      //     error: data.detail || 'User creation failed',
      //     errorData: data,
      //   };
      // }
      if (!response.ok) {
        console.log("from first")
        throw new Error(data.detail || "Failed to create user");
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      // return {
      //   success: false,
      //   status: 0,
      //   error: error.message || 'Network error occurred',
      //   errorData: null,
      // };
      console.log("from second")
      console.error("❌ Creation failed:", error);

      return { success: false, status: 500, error: error.message };
    }
  }

  async getUsersList(accessToken, pagination_data = {}){
    // Build query parameters
    const queryParams = new URLSearchParams();
    try{
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }
      
      const queryString = queryParams.toString();
      const response= await fetch(`${AUTH_BASE_URL}/users/${queryString ? `?${queryString}` : ''}`,{
        "headers": {
          "Content-Type":"application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      });

      const data = await response.json();

      if(!response.ok){
        return {
          success: false,
          status: response.status,
          error: data.detail || "Error fetching users",
          errorData: data,
        }
      }

      return {
        status: response.status,
        success: true,
        data: data,
      }

    }catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // ------------------------User roles management-----------------------------

  // Get users with their roles
  async getUserRoles(accessToken, pagination_data = {}) {
    // Build query parameters
    const queryParams = new URLSearchParams();
    try {
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }
      
      const queryString = queryParams.toString();
      const response = await fetch(`${AUTH_BASE_URL}/users/roles/get-all-users-with-roles/${queryString ? `?${queryString}` : ''}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user roles',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get available roles
  async getAvailableRoles(accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/roles/get-available-roles/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching roles',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }



  // Assign multiple roles to user
  async assignRolesToUser(userId, roleIds, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/assign-roles/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          user_id: userId,
          role_ids: roleIds,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error assigning roles',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Remove role from user
  async removeRoleFromUser(userId, roleId, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/remove-role/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          user_id: userId,
          role_id: roleId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error removing role',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  async filterUsersBySearch(query, accessToken){
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/search/?q=${query}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}` // if your API is protected
        }
      });
      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error searching users',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Update user method
  async updateUser(userId, userData, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/${userId}/update/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'User update failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get single user details
  async getUserDetails(userId, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/${userId}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user details',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


  // Delete user method
  async deleteUser(userId, accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/users/${userId}/delete/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || data.message || 'User deletion failed',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // -----------------------------uploading user data from excel file--------------

  async uploadFile(file, accessToken) {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${AUTH_BASE_URL}/users/upload/`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'File upload failed',
          errorData: data,
        };
      }

      

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }


    // Get single user details
  async getOrganizationInfos(accessToken) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/organizations/infos/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user details',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }



}

// Export a single instance
const userService = new UserService();
export default userService;